import { Button, Flex, Typography } from 'front-commons/ds';
import { useState } from 'react';
import { AccordionContentProps } from './interfaces';
import { Content } from './styles';

export function AccordionContent({ filter, handleSelectedFilters }: AccordionContentProps) {
	const [seeMore, setSeeMore] = useState(false);

	return (
		<Content>
			<Flex direction="column" gap="0.5rem" margin="1rem 0 0 0">
				{filter.options.slice(0, seeMore ? undefined : 10).map((option) => (
					<Button width="100%" variant="none" onClick={() => handleSelectedFilters({ searchedValue: option.value })}>
						<Flex width="100%" gap="0.5rem" justifyContent="start">
							<Typography variant="Paragraph/Regular" color="--text-link">
								{option.label.capitalize()}
							</Typography>

							<Typography variant="Paragraph/Regular" color="--text-secondary">
								({option.count})
							</Typography>
						</Flex>
					</Button>
				))}

				{filter.options.length > 10 && !seeMore && (
					<Button data-testid="see-more-filters-btn" width="100%" variant="none" onClick={() => setSeeMore(true)}>
						<Typography variant="Paragraph/Regular" color="--text-link">
							ver mais
						</Typography>
					</Button>
				)}
			</Flex>
		</Content>
	);
}
